// AI audio generation types — mirror the mobile/backend DTOs (specs/012-ai-generation).

export type AiClipType = 'announcement' | 'ad' | 'greeting';
export type AiJobStatus = 'pending' | 'processing' | 'completed' | 'failed';

export interface CreateAiGenerationRequest {
  clipType: string;
  inputText: string;
  voiceId: string;
  language: string;
  targetDurationSeconds?: number | null;
  backgroundMusicContentId?: string | null;
}

export interface AiGenerationResultDto {
  contentId: string;
  title: string;
  audioUrl: string;
  durationSeconds: number;
  voiceName: string;
  language: string;
}

export interface AiGenerationJobDto {
  jobId: string;
  status: AiJobStatus;
  estimatedSeconds?: number | null;
  result?: AiGenerationResultDto | null;
  error?: string | null;
}

export interface SavedClipDto {
  contentId: string;
  title: string;
  source: string;
}

export interface VoiceDto {
  voiceId: string;
  displayName: string;
  gender: string;
  language: string;
  styles: string[];
  sampleAudioUrl?: string | null;
}

export interface VoicesResponse {
  voices: VoiceDto[];
}

export interface SuggestionsResponse {
  suggestions: string[];
}

export interface QuotaStatusDto {
  enabled: boolean;
  used: number;
  limit: number;
  resetsAt?: string | null;
}

export const AI_CLIP_TYPES: AiClipType[] = ['announcement', 'ad', 'greeting'];
export const AI_LANGUAGES = ['uk-UA', 'en-US'];
export const AI_TEXT_MAX = 300;
